import { EventType, IncrementalSource } from '../types.js';
var Timer = function () {
  function Timer(actions, speed) {
    if (actions === void 0) {
      actions = [];
    }
    this.timeOffset = 0;
    this.raf = null;
    this.actions = actions;
    this.speed = speed;
  }
  Timer.prototype.addAction = function (action) {
    var index = this.findActionIndex(action);
    this.actions.splice(index, 0, action);
  };
  Timer.prototype.addActions = function (actions) {
    this.actions = this.actions.concat(actions);
  };
  Timer.prototype.start = function () {
    this.timeOffset = 0;
    var lastTimestamp = performance.now();
    var actions = this.actions;
    var self = this;
    function check() {
      var time = performance.now();
      self.timeOffset += (time - lastTimestamp) * self.speed;
      lastTimestamp = time;
      while (actions.length) {
        var action = actions[0];
        if (self.timeOffset >= action.delay) {
          actions.shift();
          action.doAction();
        } else {
          break;
        }
      }
      if (actions.length > 0 || self.liveMode) {
        self.raf = requestAnimationFrame(check);
      }
    }
    this.raf = requestAnimationFrame(check);
  };
  Timer.prototype.clear = function () {
    if (this.raf) {
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }
    this.actions.length = 0;
  };
  Timer.prototype.setSpeed = function (speed) {
    this.speed = speed;
  };
  Timer.prototype.toggleLiveMode = function (mode) {
    this.liveMode = mode;
  };
  Timer.prototype.isActive = function () {
    return this.raf !== null;
  };
  Timer.prototype.findActionIndex = function (action) {
    var start = 0;
    var end = this.actions.length - 1;
    while (start <= end) {
      var mid = Math.floor((start + end) / 2);
      if (this.actions[mid].delay < action.delay) {
        start = mid + 1;
      } else if (this.actions[mid].delay > action.delay) {
        end = mid - 1;
      } else {
        return mid + 1;
      }
    }
    return start;
  };
  return Timer;
}();
function addDelay(event, baselineTime) {
  if (event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.MouseMove) {
    var firstOffset = event.data.positions[0].timeOffset;
    var firstTimestamp = event.timestamp + firstOffset;
    event.delay = firstTimestamp - baselineTime;
    return firstTimestamp - baselineTime;
  }
  event.delay = event.timestamp - baselineTime;
  return event.delay;
}
export { Timer, addDelay };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/replay/esm/node_modules/rrweb/es/rrweb/packages/rrweb/src/replay/timer.js
// module id = null
// module chunks = 